<template>
  <section class="select-type">
    <label
      class="select-pay"
      :class="{'checked':selectType==1}">
      <el-radio
        v-model="selectType"
        label="1"
        @change="handleChange"
      >
        <div  class="flex-align-center">
          <span class="icon-block">
            <img src="@/assets/images/icon/hc.png">
          </span>
          <span class="select-span">HoldCover</span>
        </div>
      </el-radio
      >
    </label>
    <label
      class="select-pay"
      :class="{'checked':selectType==2,'disable':disable}">
      <el-radio
        v-model="selectType"
        label="2"
        :disabled="disable"
        @change="handleChange"
      >
        <div class="flex-align-center">
          <span class="icon-block">
            <img src="@/assets/images/icon/Fina.png">
          </span>
          <span class="select-span">Fina</span>
        </div>
      </el-radio
      >
    </label>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'

export default {
  name: 'select-quote-type',
  mixins: [MixinOptions, MixinRules],
  props:{
    isFina:{
      type:Boolean,
      default:false
    },
    disable:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      selectType:'1',
    }
  },
  watch:{
    isFina:{
      immediate:true,
      handler(val){
        if(val){
          this.selectType = '1'
          this.$emit('input',this.selectType)
        }
      }
    }
  },
  methods:{
    handleChange(){
      this.$emit('input',this.selectType)
    }
  }
}
</script>

<style scoped lang="scss">
.select-pay {
  border: 1px solid #d1d5da;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 16px;
  width:330px;
  display: block;
  .el-radio{
    display: flex;
    align-items: center;
  }
  &.checked{
    border-color: #409EFF;
  }
  &.disable{
    //pointer-events: none;
    //cursor: none;
  }
  .select-span {
    color: #24292e;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
  }
  .icon-block{
    display: block;
    width: 42px;
    height: 42px;
    margin: 0 20px;
    img{
      width: 42px;
    }
  }
  .margin-top {
    margin-top: 20px;
  }
}
</style>
